export function formatNumberWithPlusPrefix(number = 0) {
  if (number >= 1000) {
    const thousands = Math.floor(number / 1000);
    return `+${thousands}k`;
  }
  return `+${number}`;
}
